module.exports = __webpack_public_path__ + "img/arrow-down.2f1f42de.svg";